export const PLATFORM_CHAR_LIMITS: Record<string, number> = {
  twitter:   280,
  linkedin:  3000,
  instagram: 2200,
  reddit:    40000,
  facebook:  63206,
};

export function getCharCountClass(charCount: number, limit: number): string {
  if (limit <= 0) return "text-muted-foreground";
  const pct = charCount / limit;
  if (pct >= 1) return "text-red-500 font-bold";
  if (pct >= 0.9) return "text-amber-400 font-semibold";
  return "text-muted-foreground";
}

export function getWordCount(text: string): number {
  return text.trim().split(/\s+/).filter(Boolean).length;
}
